import { IDL } from "../target/types/hapi_core";
// HapiCore Instructions
export const HapiCoreInstructionVariants = IDL.instructions.map((ix) => ix.name);
// HapiCore Accounts
export const HapiCoreAccountVariants = IDL.accounts.map((acc) => acc.name);
// ReporterRole
export const ReporterRole = {
    Validator: { validator: {} },
    Tracer: { tracer: {} },
    Publisher: { publisher: {} },
    Authority: { authority: {} },
};
export const ReporterRoleVariants = Object.keys(ReporterRole);
// ReporterStatus
export const ReporterStatus = {
    Inactive: { inactive: {} },
    Active: { active: {} },
    Unstaking: { unstaking: {} },
};
export const ReporterStatusVariants = Object.keys(ReporterStatus);
// CaseStatus
export const CaseStatus = {
    Closed: { closed: {} },
    Open: { open: {} },
};
export const CaseStatusVariants = Object.keys(CaseStatus);
// Category
export const Category = {
    None: { none: {} },
    WalletService: { walletService: {} },
    MerchantService: { merchantService: {} },
    MiningPool: { miningPool: {} },
    Exchange: { exchange: {} },
    DeFi: { deFi: {} },
    OTCBroker: { oTCBroker: {} },
    ATM: { aTM: {} },
    Gambling: { gambling: {} },
    IllicitOrganization: { illicitOrganization: {} },
    Mixer: { mixer: {} },
    DarknetService: { darknetService: {} },
    Scam: { scam: {} },
    Ransomware: { ransomware: {} },
    Theft: { theft: {} },
    Counterfeit: { counterfeit: {} },
    TerroristFinancing: { terroristFinancing: {} },
    Sanctions: { sanctions: {} },
    ChildAbuse: { childAbuse: {} },
};
export const CategoryVariants = Object.keys(Category);
export const NetworkSchema = {
    Plain: { plain: {} },
    Solana: { solana: {} },
    Ethereum: { ethereum: {} },
    Bitcoin: { bitcoin: {} },
    Near: { near: {} },
};
export const NetworkSchemaVariants = Object.keys(NetworkSchema);
export const ACCOUNT_SIZE = {
    address: 184,
    asset: 216,
    case: 120,
    community: 192,
    network: 176,
    reporter: 128,
    reporterReward: 112,
};
//# sourceMappingURL=enums.js.map